module.exports = __webpack_public_path__ + "img/DNARepair-OVCA_GSE227019.ab76376c.png";